/* eslint-disable */
export const listPublicAlumniProfiles = /* GraphQL */ `
  query PublicAlumniProfiles(
    $filter: ModelAlumniProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    publicAlumniProfiles(
      publicProfile: x
      sortDirection: ASC
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        firstNameDisplay
        lastName
        lastNameDisplay
        isOpenToWork
        isWillingToTravel
        publicProfile
        skills
        owner
        countryCode
        stateCode
        cityName
        branch
        cohortID
        email
        isMilitarySpouse
        profilePictureKey
      }
      nextToken
    }
  }
`;
